module.exports = __webpack_public_path__ + "img/UserIcon.a99590cc.svg";